<div class="card card-custom">
  <div class="card-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <div class="card-title">
      <h3 class="card-label">{{ getBasicInfo() }}</h3>
    </div>
  </div>
  <div
    class="navi-hover scroll card-body"
    [perfectScrollbar]="{ wheelPropagation: false }"
    style="text-align: center"
  >
    <img [src]="data.entity?.pre_signed_url?.url" style="max-height: 400px; max-width: 550px" />
  </div>
  <div class="card-footer">
    <div class="d-flex justify-content-between">
      <div class="mr-2"></div>
      <div>
        <button (click)="close()" type="button" mat-raised-button matTooltip="Cancel">
          <span translate="GLOBAL.CANCEL">Cancel</span>
        </button>
      </div>
    </div>
  </div>
</div>
